import Layout from "../components/Layout";
import JobWork from "../components/_JobWork";

const JobWorkPage = (props:any) => {
    return (
    <Layout>
        <JobWork />
    </Layout>
    )
}

export default JobWorkPage